<template>
  <div class="fuel-request">
    <v-main class="page-fuel-request">
      <div class="nav-bar main-bar">
        <div
          class="tab"
          :class="{ active: activeTab === 'solicitudes' }"
          @click="switchTab('solicitudes')"
        >
          <div class="subrayado">Solicitudes</div>
        </div>
        <div
          class="tab"
          :class="{ active: activeTab === 'historico' }"
          @click="switchTab('historico')"
        >
          <div class="subrayado">Histórico</div>
        </div>
      </div>

      <div v-if="activeTab === 'solicitudes'" class="solicitudes">
        <div v-if="loadingrequest" class="loading">
          <v-progress-circular
            :size="200"
            :width="10"
            color="white"
            indeterminate
          >
            Cargando...
          </v-progress-circular>
        </div>

        <div v-else>
          <div
            v-if="!fuelreq_data || fuelreq_data.length === 0"
            class="empty-message"
          >
            <img src="../assets/i/icons/gas_meter.svg" alt="GasMeter_img" />
            <p>No hay solicitudes disponibles.</p>
            <p class="subtitle">
              En este momento no se han creado solicitudes de repostaje.
            </p>
          </div>
          <div
            v-else
            class="solicitud"
            v-for="(fuelreq, fuelIndex) in fuelreq_data"
            :key="fuelreq.id"
          >
            <div v-if="fuelreq.status === 'aprobado'" class="line_done"></div>
            <div v-else class="line"></div>
            
            <div class="cards">
              <div class="row1">
                <p class="date">{{ closed_date(fuelreq.date) }} - 13:00</p>
              </div>

              <div class="row2" v-if="fuelreq.status === 'pendiente'">
                <p class="close-text">Día de repostaje:</p>
                <p class="close-date">
                  {{ formatDate(fuelreq.date) }}
                </p>
              </div>
              <div
                class="row4"
                v-for="(ship, shipIndex) in ships"
                :key="ship.id"
              >
                <div class="ship">
                  <div class="top-row">
                    <div class="ship-name">{{ ship.name }}</div>
                    <div v-if="isEditing[fuelreq.id] && getOwner(fuelreq.id, ship.id)" class="quantity">
                      <button
                        class="btn-symbol"
                        :class="{
                          'btn-disabled':
                            getQuantity(fuelreq.id, ship.id) === 0,
                        }"
                        type="button"
                        @click="minusQuantity(fuelreq.id, ship.id)"
                      >
                        <img src="../assets/i/icons/minus.svg" alt="-" />
                      </button>

                      <input
                        type="number"
                        class="input_quantity"
                        min="0"
                        step="50"
                        placeholder="0"
                        v-model.number="shipQuantities[fuelreq.id][ship.id]"
                        @input="updateTotal(fuelreq.id)"
                        disabled
                      />

                      <button
                        class="btn-symbol"
                        type="button"
                        @click="plusQuantity(fuelreq.id, ship.id)"
                      >
                        <img src="../assets/i/icons/plus.svg" alt="+" />
                      </button>
                    </div>
                    <div v-else class="quantity-display">
                      <span class="quantity-text">
                        {{ getQuantity(fuelreq.id, ship.id) }}L
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="ships.length > 1" class="row5">
                <p class="cantidad-total">
                  Pedido total: {{ getTotalQuantity(fuelreq.id, fuelIndex) }}L
                </p>
              </div>
              <div class="row6">
                <div v-if="fuelreq.status === 'aprobado'">
                  <button class="block-btn" disabled>Enviado</button>
                </div>

                <div v-else-if="!isEditing[fuelreq.id]">
                  <button class="edit-btn" @click="startEditing(fuelreq.id)">
                    Editar
                  </button>
                </div>

                <div v-else class="edit-actions">
                  <button class="cancel-btn" @click="cancelEditing(fuelreq.id)">
                    Cancelar
                  </button>
                  <button
                    class="save-btn"
                    @click="saveData(fuelreq.id, fuelIndex)"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="activeTab === 'historico'" class="historico">
        <div class="nav-bar sub-bar">
          <div
            class="tab"
            :class="{ active: historyFilter === 'month' }"
            @click="setFilter('month')"
          >
            Mes
          </div>
          <div
            class="tab"
            :class="{ active: historyFilter === 'year' }"
            @click="setFilter('year')"
          >
            Año
          </div>
          <!-- <div
            class="tab"
            :class="{ active: historyFilter === 'all' }"
            @click="setFilter('all')"
          >
            Todo
          </div> -->
        </div>

        <div v-if="loadingrequest" class="loading">
          <v-progress-circular
            :size="200"
            :width="10"
            color="white"
            indeterminate
          >
            Cargando...
          </v-progress-circular>
        </div>
        <div v-else>
          <div class="resume">
            <div class="request-div">
              <p class="request-text">Respostajes realizados:</p>
              <p class="total-request">
                {{ historicalData.length }} solicitudes
              </p>
            </div>
            <div class="capacity-div">
              <p class="capacity-text">Mis litros totales:</p>
              <p class="total-capacity">{{ totalHistoricalLiters }}L</p>
            </div>
          </div>
          <div v-if="historicalData.length === 0" class="empty-message">
            <img
              src="../assets/i/icons/stadistic_bars.svg"
              alt="Stadistic_img"
            />
            <p>Aún no tienes repostajes</p>
            <p class="subtitle">
              Cuando participes en solicitudes aparecerán aquí tus consumos.
            </p>
          </div>

          <div v-else>
            <div
              v-for="(group, groupLabel) in groupedHistoricalData"
              :key="groupLabel"
              class="group-section"
            >
              <h3 class="group-title">
                {{ groupLabel }}
              </h3>

              <div
                v-for="(fuelreq, fuelIndex) in group"
                :key="fuelreq.id"
                class="historical-card"
              >
                <div class="date">
                  <p>{{ shortformatdate(fuelreq.date) }}</p>
                </div>
                <div class="quantities">
                  <p
                    class="quantity-text"
                    v-for="(ship, shipIndex) in ships"
                    :key="ship.id"
                  >
                    <span class="ship-name">{{ ship.name }}</span>
                    <span class="ship-quantity"
                      >({{ getOldQuantity(fuelreq.id, ship.id) }}L)</span
                    >
                  </p>
                  <p class="total" v-if="fuelreq.status === 'cancelado'">
                    Pedido cancelado
                  </p>
                  <p class="total" v-else>
                    Pedido total:
                    {{ getOldTotalQuantity(fuelreq.id, fuelIndex) }}L
                  </p>
                </div>
                <div class="status">
                  <img
                    v-if="fuelreq.status === 'aprobado'"
                    src="../assets/i/icons/check.svg"
                    alt="Aprobado"
                  />
                  <img
                    v-else-if="fuelreq.status === 'cancelado'"
                    src="../assets/i/icons/cancel.svg"
                    alt="Cancelado"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-alert
      id="alert_fuel_request"
      type="error"
      :value="show_alert_error"
      dark
      transition="scale-transition"
      >{{ msg_error|| "Ha ocurrido un error al guardar la solicitud." }}</v-alert
    >
  </div>
</template>

<script>
import LoadingComponent from "../components/LoadingComponent.vue";

export default {
  name: "fuelrequest",
  components: {
    LoadingComponent,
  },
  data() {
    return {
      fuelRequest: [],
      shipQuantities: {},
      savedQuantities: {},
      oldshipQuantities: {},
      oldSavedQuantites: {},
      isEditing: {},
      isProcessing: false,
      activeTab: "solicitudes",
      historyFilter: "month",
      historicalData: [],
      loadingrequest: false,
      pendingSaves: 0,
      show_alert_error: false,
      msg_error: "",
    };
  },
  computed: {
    ships() {
      if (this.$store.state.ships.results !== undefined) {
        return this.$store.state.ships.results;
      } else {
        return this.$store.state.ships;
      }
    },
    fuelreq_data() {
      return this.$store.state.fuelRequest;
    },
    totalHistoricalLiters() {
      let total = 0;
      this.historicalData.forEach((fuelreq) => {
        if(fuelreq.status == "aprobado"){
          const shipQuantities = this.oldshipQuantities[fuelreq.id] || {};
          for (const quantity of Object.values(shipQuantities)) {
            total += quantity || 0;
          }
        }
      });

      return total;
    },
    groupedHistoricalData() {
      const grouped = {};
      const monthNames = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      this.historicalData.forEach((item) => {
        const date = new Date(item.date);
        const year = date.getFullYear();
        const month = date.getMonth(); // 0-11

        const key = `${monthNames[month]} ${year}`;

        if (!grouped[key]) {
          grouped[key] = [];
        }

        grouped[key].push(item);
      });

      return grouped;
    },
  },
  methods: {
    initializeQuantities() {
      this.fuelreq_data.forEach((fuelreq) => {
        this.$set(this.shipQuantities, fuelreq.id, {});
        this.$set(this.savedQuantities, fuelreq.id, {});
        this.$set(this.isEditing, fuelreq.id, false);

        this.ships.forEach((ship) => {
          let existingQuantity = 0;
          const existingShipFuel = (fuelreq.shipfuelrequest || []).find(
            (sfr) => sfr.ship.id === ship.id
          );

          if (existingShipFuel) {
            existingQuantity = existingShipFuel.quantity || 0;
          }

          this.$set(this.shipQuantities[fuelreq.id], ship.id, existingQuantity);
          this.$set(
            this.savedQuantities[fuelreq.id],
            ship.id,
            existingQuantity
          );
        });
        this.loadingrequest = false;
      });
      this.historicalData.forEach((histdat) => {
        this.$set(this.oldSavedQuantites, histdat.id, {});
        this.$set(this.oldshipQuantities, histdat.id, {});
        this.ships.forEach((ship) => {
          let existingOldQuantity = 0;
          const existingOldShipFuel = (histdat.shipfuelrequest || []).find(
            (sfr) => sfr.ship.id === ship.id
          );

          if (existingOldShipFuel) {
            existingOldQuantity = existingOldShipFuel.quantity || 0;
          }

          this.$set(
            this.oldshipQuantities[histdat.id],
            ship.id,
            existingOldQuantity
          );
        });
      });
      this.loadingrequest = false;
    },

    getQuantity(fuelId, shipId) {
      return this.shipQuantities[fuelId]?.[shipId] || 0;
    },
    getOwner(fuelId, shipId) {
      let fuel_request = this.fuelreq_data.find((element) => element.id === fuelId)
      let ship_fuel_request = fuel_request.shipfuelrequest.find((element) => element.ship.id === shipId)

      if (ship_fuel_request){
        return ship_fuel_request.your
      }else{
        return true
      }
    },

    getOldQuantity(fuelId, shipId) {
      return this.oldshipQuantities[fuelId]?.[shipId] || 0;
    },

    startEditing(fuelId) {
      this.ships.forEach((ship) => {
        this.$set(
          this.savedQuantities[fuelId],
          ship.id,
          this.shipQuantities[fuelId][ship.id]
        );
      });
      this.$set(this.isEditing, fuelId, true);
    },

    cancelEditing(fuelId) {
      this.ships.forEach((ship) => {
        this.$set(
          this.shipQuantities[fuelId],
          ship.id,
          this.savedQuantities[fuelId][ship.id]
        );
      });
      this.$set(this.isEditing, fuelId, false);
    },
    saveData(fuelId, fuelIndex) {
      const quantities = this.shipQuantities[fuelId];
      const fuelreq = this.fuelreq_data[fuelIndex];

      this.pendingSaves = 0;
      let hasChanges = false;
      Object.entries(quantities).forEach(([shipId, quantity]) => {
        const oldQuantity = this.savedQuantities[fuelId][shipId] || 0;
        if (oldQuantity !== quantity) {
          hasChanges = true;
          const existingShipFuel = (fuelreq.shipfuelrequest || []).find(
            (sfr) => sfr.ship.id === Number(shipId)
          );
          const shipFuelRequestId = existingShipFuel
            ? existingShipFuel.id
            : null;
          if (quantity >= 150 || quantity === 0) {
            if (quantity === 0 && existingShipFuel) {
              this.pendingSaves++;
              this.$api
                .deleteShipFuelRequest(existingShipFuel.id)
                .then(() => {
                  this.onSaveComplete(fuelId, shipId, 0);
                })
                .catch((error) => {
                  console.error("Error al eliminar:", error);
                  this.pendingSaves--;
                });
            } else if (quantity > 0) {
              const payload = {
                ship_id: Number(shipId),
                fuel_request_id: fuelreq.id,
                quantity: quantity,
              };

              this.pendingSaves++;

              if (existingShipFuel) {
                this.$api
                  .saveshipfuelrequest(shipFuelRequestId, payload)
                  .then((response) => {
                    this.onSaveComplete(
                      fuelId,
                      shipId,
                      quantity,
                      response.data
                    );
                  })
                  .catch((error) => {
                    console.error("Error al actualizar:", error);
                    this.pendingSaves--;
                    if (!this.show_alert_error){
                      this.show_alert_error = true;
                      setTimeout(() => {
                        this.show_alert_error = false;
                        this.msg_error= "";
                      }, 3000);
                    }
                  });
              } else {
                this.$api
                  .saveshipfuelrequest(shipFuelRequestId, payload)
                  .then((response) => {
                    this.onSaveComplete(
                      fuelId,
                      shipId,
                      quantity,
                      response.data
                    );
                    if (!fuelreq.shipfuelrequest) {
                      this.$set(fuelreq, "shipfuelrequest", []);
                    }
                    fuelreq.shipfuelrequest.push(response.data);
                  })
                  .catch((error) => {
                    console.error("Error al crear:", error);
                    this.pendingSaves--;
                    if (!this.show_alert_error){
                      this.show_alert_error = true;
                      setTimeout(() => {
                        this.show_alert_error = false;
                        this.msg_error= "";
                      }, 3000);
                    }
                  });
              }
            }
          } else {
            if (!this.show_alert_error){
              this.msg_error= "No se pueden guardar menos de 150 litros por barco.";
              this.show_alert_error = true;
              setTimeout(() => {
                this.show_alert_error = false;
                this.msg_error= "";
              }, 3000);
            }
          }
        }
      });

      if (!hasChanges) {
        this.$set(this.isEditing, fuelId, false);
      }
    },

    onSaveComplete(fuelId, shipId, newQuantity, responseData = null) {
      this.$set(this.savedQuantities[fuelId], shipId, newQuantity);

      this.pendingSaves--;
      if (this.pendingSaves === 0) {
        this.$api
          .fuelrequest()
          .then((response) => {
            if (response.data) {
              this.$store.commit("fuelRequest", response.data);
              this.initializeQuantities();
            }
          })
        this.$api.ships();
        this.$set(this.isEditing, fuelId, false);
      }
    },

    plusQuantity(fuelId, shipId) {
      if (this.isProcessing) return;
      this.isProcessing = true;

      setTimeout(() => {
        const currentValue = this.getQuantity(fuelId, shipId);
        this.$set(this.shipQuantities[fuelId], shipId, currentValue + 50);
        this.isProcessing = false;
      }, 50);
    },

    minusQuantity(fuelId, shipId) {
      const currentValue = this.getQuantity(fuelId, shipId);
      if (currentValue === 0) return;
      if (this.isProcessing) return;

      this.isProcessing = true;

      setTimeout(() => {
        const value = this.getQuantity(fuelId, shipId);
        this.$set(this.shipQuantities[fuelId], shipId, value - 50);
        this.isProcessing = false;
      }, 50);
    },

    calculateTotal(fuelId, fuelIndex) {
      const ships = this.shipQuantities[fuelId] || {};
      let total = 0;
      for (const shipId in ships) {
        total += ships[shipId] || 0;
      }
      return total;
    },

    getTotalQuantity(fuelId, fuelIndex) {
      return this.calculateTotal(fuelId, fuelIndex);
    },
    calculateOldTotal(fuelId, fuelIndex) {
      const ships = this.oldshipQuantities[fuelId] || {};
      let total = 0;
      for (const shipId in ships) {
        total += ships[shipId] || 0;
      }
      return total;
    },

    getOldTotalQuantity(fuelId, fuelIndex) {
      return this.calculateOldTotal(fuelId, fuelIndex);
    },

    updateTotal(fuelId) {
      this.calculateTotal(fuelId);
    },

    formatDate(date) {
      const dias = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const meses = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sept",
        "Oct",
        "Nov",
        "Dic",
      ];

      const dateParts = date.split("-");
      const fecha = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

      return `${dias[fecha.getDay()]} , ${dateParts[2]} ${
        meses[fecha.getMonth()]
      } ${dateParts[0]}`;
    },
    shortformatdate(date) {
      const dateParts = date.split("-");
      return `${dateParts[2]}/${dateParts[1]}`;
    },

    closed_date(date) {
      const dateParts = date.split("-");
      const fechacierre = new Date(
        dateParts[0],
        dateParts[1] - 1,
        dateParts[2]
      );
      const dias = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
      fechacierre.setDate(fechacierre.getDate() - 1);
      return `${dias[fechacierre.getDay()]} ${String(
        fechacierre.getDate()
      ).padStart(2, "0")}/${String(fechacierre.getMonth() + 1).padStart(
        2,
        "0"
      )}`;
    },

    fetchHistoricalData() {
      let params = {};

      const now = new Date();

      if (this.historyFilter === "month") {
        const startCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        params.date_start = new Intl.DateTimeFormat('en-CA').format(startCurrentMonth);
      } else if (this.historyFilter === "year") {
        const startCurrentYear = new Date(now.getFullYear(), 1, 1);
        params.date_start = new Intl.DateTimeFormat('en-CA').format(startCurrentYear);
      } else {
        params.date_start = "2000-01-01";
      }
      params.date_end = new Intl.DateTimeFormat('en-CA').format(new Date(now));
      this.$api
        .fuelrequestHistory(params)
        .then((response) => {
          const allData = response.data.results || [];

          const filteredData = allData.filter((req) => {
            if (!req.shipfuelrequest || req.shipfuelrequest.length === 0) {
              return false;
            }
            const hasQuantity = req.shipfuelrequest.some(
              (sfr) => sfr.quantity && sfr.quantity > 0
            );
            return (
              hasQuantity && ["aprobado", "cancelado"].includes(req.status)
            );
          });

          this.historicalData = filteredData;
          this.initializeQuantities();
          this.loadingrequest = false;
        })
        .catch((error) => {
          console.error("Error al cargar histórico:", error);
          this.historicalData = [];
        });
    },

    switchTab(tab) {
      this.loadingrequest = true;
      this.activeTab = tab;
      if (tab === "historico") {
        this.fetchHistoricalData();
      } else {
        this.loadingrequest = false;
      }
    },

    setFilter(filter) {
      this.loadingrequest = true;
      this.historyFilter = filter;
      this.fetchHistoricalData();
    },
  },

  mounted() {
    this.loadingrequest = true;
    this.$api.ships();
    this.$api
      .fuelrequest()
      .then((response) => {
        if (response.data) {
          this.$store.commit("fuelRequest", response.data);
        }
        this.initializeQuantities();
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$store.commit("token", null);
          this.$router.push("/login");
        } else {
          console.error("Error al cargar pedidos de combustible:", error);
        }
      });

    this.show = true;
    this.$store.commit("pageTitle", "Repostaje");
    this.$store.commit("pageIcon", "gas_station.svg");
    this.$gtag.pageview(this.$route);
  },
};
</script>
